(function () {
  "use strict";

  var SAFE_CART = "/cart";
  var CHECKOUT_LABEL = "Secure Checkout";

  function normalizeRoutes() {
    if (!window.routes) return;
    window.routes.cart_url = SAFE_CART;
  }

  function normalizeHref(href) {
    if (!href || typeof href !== "string") return href;
    if (href.indexOf("/cart/c/") !== -1) return SAFE_CART;
    return href;
  }

  function fixCartLinks(root) {
    var scope = root || document;
    scope.querySelectorAll('a[href*="/cart/c/"]').forEach(function (a) {
      a.setAttribute("href", SAFE_CART);
    });
    scope.querySelectorAll('form[action*="/cart/c/"]').forEach(function (f) {
      f.setAttribute("action", SAFE_CART);
    });
  }

  function relabelCheckout(scope) {
    (scope || document).querySelectorAll("button, a, input[type='submit'], span").forEach(function (el) {
      var text = (el.textContent || el.value || "").trim();
      if (!/continue with shopify/i.test(text)) return;
      if (el.tagName === "INPUT") el.value = CHECKOUT_LABEL;
      else el.textContent = CHECKOUT_LABEL;
    });
  }

  function onClickCapture(e) {
    var link = e.target.closest('a[href*="/cart/c/"]');
    if (!link) return;
    e.preventDefault();
    window.location.assign(SAFE_CART);
  }

  function patchProductFormRedirect() {
    if (!window.customElements || customElements.get("product-form")) return;
    var ProductForm = customElements.get("product-form");
    if (!ProductForm || ProductForm.__utCartPatched) return;
    var orig = ProductForm.prototype.onSubmitHandler;
    if (typeof orig !== "function") return;
    ProductForm.prototype.onSubmitHandler = function (evt) {
      normalizeRoutes();
      return orig.call(this, evt);
    };
    ProductForm.__utCartPatched = true;
  }

  function init() {
    normalizeRoutes();
    fixCartLinks(document);
    relabelCheckout(document);
    document.addEventListener("click", onClickCapture, true);
    patchProductFormRedirect();

    var obs = new MutationObserver(function (mutations) {
      normalizeRoutes();
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          fixCartLinks(node);
          relabelCheckout(node);
        });
      });
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
